<template>
  <div class="banner">
    <div id="bg"></div>
    <div class="content">
      <div class="main">
        <div id="mainText">
          <h1>NS4 Gear</h1>
          <p>方便、快捷、高效的开源框架</p>
        </div>
      </div>
      <ul class="modules">
        <li class="item">
          <div class="icon">
            <div class="icon-wrap"><icon name="log" class="module-icon"></icon></div>
          </div>
          <div class="text">
            <h3>日志查询</h3>
            <p class="desc">用于日志采集、存储、分析展现</p>
            <p><router-link :to="{name: ''}">了解更多</router-link></p>
          </div>
        </li>
        <li class="item">
          <div class="icon">
            <div class="icon-wrap"><icon name="id" class="module-icon"></icon></div>
          </div>
          <div class="text">
            <h3>ID 生成器</h3>
            <p class="desc">使用有意义、有序的序列号生成全局唯一ID</p>
            <p><router-link :to="{name: ''}">了解更多</router-link></p>
          </div>
        </li>
        <li class="item">
          <div class="icon">
            <div class="icon-wrap"><icon name="calendar" class="module-icon"></icon></div>
          </div>
          <div class="text">
            <h3>节假日管理</h3>
            <p class="desc">维护节假日，并提供接口判断某天是否节假日</p>
            <p><router-link :to="{name: ''}">了解更多</router-link></p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import fragmentShader from '../shader/ocean.fsh' // 片元着色器
import vertexShader from '../shader/ocean.vsh' // 顶点着色器
// import MoveControl from '../js/MoveControl'

export default {
  name: 'Banner',
  data () {
    return {
      startAnimate: false
    }
  },
  mounted () {
    this.loadScript('/static/js/three.min.js', this.initCanvas)
    /* let ctrl = new MoveControl(document.getElementById('mainText'))
    ctrl.start() */
  },
  beforeDestroy () {
    this.startAnimate = false
  },
  methods: {
    loadScript (src, onloadFun) {
      function initBackground () {
        try {
          onloadFun()
        } catch (e) {
          let parentEle = document.getElementById('bg')
          parentEle.style.background = 'url(/static/img/ocean_bg.png) no-repeat center'
          parentEle.style.backgroundSize = 'cover'
        }
      }
      if (document.getElementById('three')) {
        initBackground()
        return
      }
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = src
      script.id = 'three'
      script.onload = initBackground
      document.body.appendChild(script)
    },
    initCanvas () {
      let that = this
      let THREE = window.THREE
      let parentEle = document.getElementById('bg')
      let WIDTH = null // 画布宽度
      let HEIGHT = null // 画布高度
      let renderer = null // 渲染器
      let camera = null // 相机
      let scene = null // 场景
      let clock = null // 时钟
      let delta = 0 // 时间偏移量

      // 设置宽高
      function setWH () {
        WIDTH = window.innerWidth > 980 ? window.innerWidth : 980
        HEIGHT = window.innerHeight < WIDTH * 0.389 ? WIDTH * 0.389 : window.innerHeight
      }

      // 执行动画
      function animate () {
        if (that.startAnimate) {
          requestAnimationFrame(animate)
        }
        delta = clock.getDelta()
        // console.log(delta)
        uniforms.iTime.value += delta
        renderer.render(scene, camera)
      }

      setWH() // 设置宽高
      // HTML中无canvas标签，自动创建
      renderer = new THREE.WebGLRenderer({antialias: true})
      renderer.setSize(WIDTH, HEIGHT)
      parentEle.appendChild(renderer.domElement)

      // 将背景色（用于清除画面的颜色)
      renderer.setClearColor(0xeeeeee)
      // 场景
      scene = new THREE.Scene()
      // 摄像机
      camera = new THREE.PerspectiveCamera(45, WIDTH / HEIGHT, 1, 2000)
      camera.position.set(0, 0, 360)
      // 照相机默认沿z轴负方向观察，通过设置lookAt的位置可以改变观察的方向
      camera.lookAt(new THREE.Vector3(0, 0, 0))
      scene.add(camera)

      /* 物体 */
      let uniforms = {
        iTime: {value: 1.0},
        iResolution: {value: new THREE.Vector2(WIDTH * 1.0, HEIGHT * 1.0)}
      }

      let material = new THREE.ShaderMaterial({
        uniforms: uniforms,
        vertexShader,
        fragmentShader
      })

      let geom = new THREE.PlaneBufferGeometry(WIDTH, HEIGHT)
      let mesh = new THREE.Mesh(geom, material)
      scene.add(mesh)

      renderer.render(scene, camera)

      clock = new THREE.Clock()
      this.startAnimate = true

      animate()
      window.addEventListener('resize', () => {
        setWH()
        camera.aspect = WIDTH / HEIGHT // 设置屏幕长宽比
        camera.updateProjectionMatrix()
        renderer.setSize(WIDTH, HEIGHT)
        uniforms.iResolution.value = new THREE.Vector2(WIDTH * 1.0, HEIGHT * 1.0)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.banner{
  min-height: 3.89rem;
  #bg{
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    z-index: 0;
  }
  .content{
    position: absolute;
    top: $app-header-height;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    z-index: 1;
    color: #FFF;
    ul, li{
      list-style: none;
    }
    .main{
      position: absolute;
      top: 40%;
      left: 2rem;
      transform: translate(0, -50%);
      h1{
        font-size: .5rem;
        text-shadow: 0 1px .5px hsl(0,0%,95%),
        0 2px .5px hsl(0,0%,90%),
        0 3px .5px hsl(0,0%,85%),
        0 4px .5px hsl(0,0%,80%),
        0 5px 0 hsl(0,0%,75%),
        0 5px 10px black;
      }
      p{
        font-size: .25rem;
        text-shadow: 2px 2px .041rem rgba(0, 0, 0, .8)
      }
      /*#mainText {
        transform: translate(0, 0);
        transition: transform .3s ease;
      }*/
    }
    .modules{
      position: absolute;
      top: 50%;
      right: 5%;
      width: 3rem;
      min-width: 345px;
      transform: translate(0, -50%);
      .item{
        position: relative;
        margin: .1rem 0;
        padding: .13rem .13rem .13rem .75rem;
        background-color: rgba(0, 0, 0, .6);
        border-radius: .15rem;
        overflow: hidden;
        .icon{
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          width: .75rem;
          .icon-wrap{
            position: absolute;
            background-color: #FFF;
            width: .5rem;
            height: .5rem;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border-radius: 50%;
            color: #1999de;
            text-align: center;
            line-height: .5rem;
            font-size: .3rem;
            .module-icon{
              vertical-align: -.15em;
            }
          }
        }

        .text{
          h3{
            font-size: .15rem;
            line-height: .3rem;
            margin-bottom: .08rem;
          }
          .desc{
            font-size: .1rem;
            line-height: 2;
          }
          a{
            font-size: .1rem;
            color: #caf1ff;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ocean/components/Banner.vue